import standardAPI from '@/api/standard_items';

const responseUrl = '/organisation-tours/countries';

const state = {
  countries: [],
  countries_MetaData: {},
  countries_status: '',
  countries_page: 1,
  countries_perPage: 10,
};

const getters = {
  get_countries: (state) => {
    return state.countries;
  },
  get_countries_status: (state) => {
    return state.countries_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_countries ({ commit }, getOptions) {

    commit('DATA_COUNTRIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_COUNTRIES_UPDATE_SUCCESS', response);
            commit('DATA_COUNTRIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_COUNTRIES_READY');
            reject(response);
          } else {
            commit('DATA_COUNTRIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_countries_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_country ({ commit, dispatch }, itemData) {
    commit('DATA_COUNTRIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_COUNTRIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_COUNTRIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_country ({ commit, dispatch }, itemData) {
    commit('DATA_COUNTRIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_COUNTRIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_COUNTRIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_countries ({ commit, dispatch }, itemData) {
    commit('DATA_COUNTRIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_COUNTRIES_REQUEST');
          resolve();
        } else {
          commit('DATA_COUNTRIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_country ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_country_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.countries_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.countries_perPage = max;
  },
  DATA_COUNTRIES_READY: (state) => {
    state.countries_status = 'ready';
  },
  DATA_COUNTRIES_REQUEST: (state) => {
    state.countries_status = 'loading';
  },
  DATA_COUNTRIES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.countries_MetaData.meta = response.meta;
      state.countries_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.countries = response.data || [];
    }
    state.countries_status = 'success';
  },
  DATA_COUNTRIES_ERROR: (state) => {
    state.countries_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
